import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const KEY = "ops_auth_token";
const API = process.env.REACT_APP_BACKEND_URL;

// Set the auth header synchronously at module load so the first API calls
// (fired by child components before parent effects run) carry the token.
const saved = localStorage.getItem(KEY);
if (saved) axios.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (r) => r,
      (err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem(KEY);
          delete axios.defaults.headers.common["Authorization"];
          setToken(null);
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  const login = async (username, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { username, password });
    localStorage.setItem(KEY, data.token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    setToken(data.token);
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    delete axios.defaults.headers.common["Authorization"];
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthed: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
